import styled from 'styled-components';

export const NavContainer = styled.div`
    display: flex;
    width: 100%;
    height: 85px;
    align-items: center;
    justify-content: space-between;
`;
